(function() {
  'use strict';
  angular.module('common')
  .filter('benefitBlock', function($filter) {
    return function(rules) {
      var benefitBlockFound = false;
      angular.forEach(rules, function(rule, key) {
        if(rule.isBenefitBlock) {
          benefitBlockFound = true;
        }
      });
      return benefitBlockFound;
    }
  });
})();